import { MuiColorInput } from 'mui-color-input';
import React from 'react';
import { convertColorToARGB, convertColorToRGBA } from '../../utils/formatGradient';

export class ColorPicker extends React.Component {
    handleChangeColor = (color) => {
        this.props.onChange(convertColorToARGB(color));
    };

    render() {
        const currentColor = this.props.color || { A: 1, R: 255, G: 255, B: 255 };
        return (
            <MuiColorInput
                sx={{ mr: 2 }}
                value={convertColorToRGBA(currentColor)}
                onChange={(color) =>
                    this.handleChangeColor(color)
                }
            />
        );
    }
}